import React from "react";
import { Card, Typography } from "antd";
import Footer from "../Components/layouts/Footer";
import Navbar from "../Components/layouts/Navbar";
import Page from "../Components/layouts/Page";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import default_img from "./../img/pattern/default.jpg";

const VacancyDetailPage = () => {
  const location = useLocation();
  const { vacancyItem } = location.state;
  console.log("Received vacancy item:", vacancyItem);

  // Determine if the screen is large
  const isLargeScreen = window.innerWidth >= 1200;
  const isMobile = useMediaQuery({ maxWidth: 767 });

  const { Text } = Typography;

  const styles = {
    cardContainer: {
      display: "flex",
      justifyContent: "center",
      padding: "20px",
    },
    card: {
      //maxWidth: "1200px",
      width: "100%",
      boxSizing: "border-box",
      padding: "20px",
    },
    title: {
      color: "#333",
      fontWeight: "bold",
      fontFamily: "Roboto, sans-serif",
      textAlign: "center",
      display: "block",
      fontSize: isMobile ? "1.6rem" : "3rem",
    },
    date: {
      color: "#666",
      fontSize: "16px",
      fontFamily: "Roboto, sans-serif",
      // textAlign: "left",
      marginBottom: "20px",
      display: "block",
      textAlign: "center",
    },
    imageContainer: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
    },
    responsiveImage: {
      width: "100%",
      height: "auto",
      maxHeight: "600px",
      objectFit: "cover",
    },
    responsiveImageLarge: {
      width: "800px",
      height: "600px",
    },
    bodyText: {
      color: "#444",
      fontSize: isMobile ? "12px" : "16px",
      fontFamily: "Roboto, sans-serif",
      marginTop: "20px",
      textAlign: "justify",
      //  padding: isLargeScreen ? "20px" : "",
    },
  };

  return (
    <Page>
      <Navbar />
      <div className="page-content woocommerce">
        <div className="container clear-fix">
          <div className="grid-col-row">
            <div style={styles.cardContainer}>
              <Card style={styles.card}>
                <Typography>
                  <Text style={styles.title}>{vacancyItem.title}</Text>
                  <Text style={styles.date}>{vacancyItem.published_at}</Text>
                </Typography>
                <br />
                <div style={styles.imageContainer}>
                  <img
                    alt={vacancyItem.title}
                    src={
                      vacancyItem?.image_url
                        ? vacancyItem.image_url
                        : default_img
                    }
                    style={{
                      ...styles.responsiveImage,
                      ...(isLargeScreen && styles.responsiveImageLarge),
                    }}
                  />
                </div>
                <br />
                <div
                  style={styles.bodyText}
                  dangerouslySetInnerHTML={{ __html: vacancyItem.body }}
                ></div>
                {vacancyItem.files[0]?.file_url ? (
                  <p
                    style={{
                      ...styles.bodyText,
                      fontSize: isMobile ? "12px" : "16px",
                    }}
                  >
                    Click this <a href={vacancyItem.files[0].file_url}>link</a>{" "}
                    to download the application and other details.
                  </p>
                ) : null}
              </Card>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </Page>
  );
};

export default VacancyDetailPage;
